module.exports = __webpack_public_path__ + "static/media/SDFSA_6-634w.6c7c4bb2.webp";